module.exports = __webpack_public_path__ + "img/IMG_1826.a3599c22.jpg";